import { IUtilizationUsers } from '~/store/utilization/types';
import { getItem, setItem } from '.';

export const storeUtilizationData = (data: IUtilizationUsers): void => setItem('utilization', data);
export const getUtilizationData = (): IUtilizationUsers => getItem('utilization');
